import {Component, Input, OnInit} from '@angular/core';
import {ChartData, ChartDataSets, ChartOptions, ChartType} from 'chart.js';
import {Label} from 'ng2-charts';

@Component({
    selector: 'app-bar-chart',
    templateUrl: './bar-chart.component.html',
    styleUrls: ['./bar-chart.component.scss']
})
export class BarChartComponent implements OnInit {
    @Input() chartInput;
    stepSize = 1;
    @Input() chartMax;
    @Input() mode;
    barChartOptions: ChartOptions;
    barChartLabels: Label[];
    barChartType: ChartType = 'bar';
    barChartLegend = false;
    barChartPlugins = [];
    barChartData: ChartDataSets[] = [];

    constructor() {
    }

    ngOnInit(): void {
        this.initBarChartOptions();
        this.initBarChartDataAndLabels();
        this.barChartData[0].data = this.mode === 'affirmations' ?
            [this.chartInput[0], this.chartInput[1], this.chartInput[2]] :
            [this.chartInput[0], this.chartInput[1], this.chartInput[2]];

    }

    initBarChartDataAndLabels() {
        this.barChartData =
            this.mode === 'affirmations' ? [
                    {
                        data: [0, 0, 0],
                        backgroundColor: ['green', '#df1326', '#fcb502']
                    }
                ] :
                [
                    {
                        data: [0, 0, 0],
                        backgroundColor: ['green', '#df1326', '#fcb502']
                    }
                ];
        this.barChartLabels = this.mode === 'affirmations' ?
            ['Συμπλήρωσαν', 'Ακύρωσαν', 'Δεν Απάντησαν'] :
            ['Αποδέχτηκαν', 'Απέρριψαν', 'Δεν Απάντησαν'];

    }
    initBarChartOptions() {
        this.barChartOptions =  {
            legend: {
                labels: {
                    fontFamily: 'Century Gothic,san-serif;'
                }
            },
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                xAxes: [{
                    gridLines: {
                        color: 'rgba(0, 0, 0, 0)',
                    }
                }],
                yAxes: [{
                    ticks: {
                        beginAtZero: true,
                        stepSize: this.stepSize,
                        max: this.chartMax,
                        min: 0
                    }
                }]
            }
        };
    }

}
